import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-material-landing-page',
  templateUrl: './material-landing-page.component.html',
  styleUrls: ['./material-landing-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialLandingPageComponent {}
